import React, { useState, Fragment } from "react";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Add, Delete, Cancel, CheckCircle, Edit, LockOpen, MailOutline, SyncAlt } from "@material-ui/icons";
import AddNewMemberPopup from "../../../NestedComponents/widgets/addNewMemberPopup";
import config from "../../../config";
import Swal from "sweetalert2";
import { isMemberActive } from "./memberOrdering";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@material-ui/core";

function Memberships(props) {
  const role = localStorage.getItem("role");
  const canEditMembers = props.isAllowedEditsInPopup;
  const [isBtaxMemberShipEdit, setIsBtaxMemberShipEdit] = useState(new Array(props.btaxMembers.length).fill(false));
  const [isBquickMemberShipEdit, setIsBquickMemberShipEdit] = useState(new Array(props.bquickMembers.length).fill(false));
  const [btaxMemberTransfer, setBtaxMemberTransfer] = useState(new Array(props.btaxMembers.length).fill({ isTransfering: false }));
  const [bquickMemberTransfer, setBquickMemberTransfer] = useState(new Array(props.bquickMembers.length).fill({ isTransfering: false }));
  const [isNewMemberPopupOpen, setIsNewMemberPopupOpen] = useState(false);
  const [newMemberType, setNewMemberType] = useState("");
  const cardJobTitle = props.userData.clientJobTitle;

  return (
    <div>
      <AddNewMemberPopup
        tryAddNewMemberAndPushList={tryAddNewMemberAndPushList}
        isOpen={isNewMemberPopupOpen}
        closePopup={() => setIsNewMemberPopupOpen(false)}
        newMemberType={newMemberType}
        cardJobTitle={cardJobTitle}
      />

      <hr />
      <div className="mb-20">
        <h5 className="yellow-color">משתמשים</h5>
      </div>
      <div className="relative">
        <h6 className="black-color underline">ביטקס</h6>
        <Add
          onClick={() => {
            if (props.btaxMembers.length >= config.maxMembersAllowedPerOffice) return Swal.fire("מקסימום משתמשים במשרד זה", "", "warning");
            setNewMemberType("btaxMembers");
            setIsNewMemberPopupOpen(true);
          }}
          className="icon-circles yellow-color adjust-add-btn"
        />
      </div>
      {props.focusedViewTypes.includes("btax") || props.focusedViewTypes.includes("all") ? (
        <table>
          {props.btaxMembers.map((member, index) => {
            //indication that a member was paid for in a sale (had at least related sale and the end subscription date is in the future)
            const isMemberSold = Boolean(member?.relatedSales?.length) && new Date(member.endOfSubscription) > new Date();
            return (
              <Fragment key={member._id}>
                <tbody>
                  <tr>
                    <td>
                      ---- <b className={isMemberActive(member) ? "black-color" : "text-danger"}>{index + 1}</b> ----
                      {isMemberSold && (
                        <>
                          <br />
                          <p style={{ ...(isMemberSold ? { backgroundColor: "#e9d700", color: "#0012e9", textAlign: "center" } : {}) }}>
                            משתמש נמכר
                            <br />
                            (תוקף+מכירה)
                          </p>
                        </>
                      )}
                    </td>
                    <td className="relative pb-40">
                      <div className="memberships-icons">
                        {isBtaxMemberShipEdit[index] ? (
                          <Fragment>
                            <div className="inline-block animation-right">
                              {props.isAllowedEditsInPopup ? (
                                <Delete
                                  style={{ fontSize: 29 }}
                                  onClick={() =>
                                    props
                                      .handleMemberUpdate("btaxMembers", index, "DELETE")
                                      .then((isUpdated) => isUpdated && deleteDone("btaxMembers", index))
                                  }
                                  className="icon-circles active-color"
                                />
                              ) : null}

                              {canEditMembers ? (
                                <CheckCircle
                                  style={{ fontSize: 29 }}
                                  className="success-color mr-20 icon-circles"
                                  onClick={() =>
                                    props
                                      .handleMemberUpdate("btaxMembers", index, "UPDATE")
                                      .then((isUpdated) => isUpdated && changeEditableState("btax", index, false))
                                  }
                                />
                              ) : null}
                            </div>

                            <Cancel
                              style={{ fontSize: 29 }}
                              onClick={() => changeEditableState("btax", index, false)}
                              className="mr-20 icon-circles"
                            />

                            <div className="left mt-20 animation-down">
                              <LockOpen
                                style={{ fontSize: 29 }}
                                className="brown-color mr-20 icon-circles"
                                onClick={() =>
                                  props
                                    .initMemberReconf("btaxMembers", index, "PASS_RESET")
                                    .then(() => changeEditableState("btax", index, false))
                                }
                              />

                              <div className="mt-20 relative">
                                {btaxMemberTransfer[index].isTransfering ? (
                                  <div className="change-member-card">
                                    <input
                                      type="txt"
                                      value={btaxMemberTransfer[index].newCardNum || ""}
                                      onChange={(e) =>
                                        changeTransferingState("btax", index, {
                                          ...btaxMemberTransfer[index],
                                          newCardNum: e.target.value
                                        })
                                      }
                                    />
                                    <button
                                      onClick={() =>
                                        props.transferMemberToOtherCard("btaxMembers", index, btaxMemberTransfer[index].newCardNum)
                                      }
                                    >
                                      שנה
                                    </button>
                                  </div>
                                ) : null}

                                {props.isAllowedEditsInPopup ? (
                                  <SyncAlt
                                    style={{ fontSize: 29 }}
                                    className="primary-color mr-20 icon-circles"
                                    onClick={() =>
                                      changeTransferingState("btax", index, {
                                        ...btaxMemberTransfer[index],
                                        isTransfering: !btaxMemberTransfer[index].isTransfering
                                      })
                                    }
                                  />
                                ) : null}
                              </div>

                              {member.isEmailConfirmed ? null : (
                                <div className="mt-20">
                                  <MailOutline
                                    style={{ fontSize: 29 }}
                                    className="yellow-color mr-20 icon-circles"
                                    onClick={() =>
                                      props
                                        .initMemberReconf("btaxMembers", index, "EMAIL_CONF")
                                        .then(() => changeEditableState("btax", index, false))
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          </Fragment>
                        ) : canEditMembers ? (
                          <Edit
                            style={{ fontSize: 29 }}
                            onClick={() => changeEditableState("btax", index, true)}
                            className="icon-circles"
                          />
                        ) : (
                          null
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>נעילת תחנות עבודה</td>
                    <td>
                      <div className={`inline-block ${isBtaxMemberShipEdit[index] ? "pointer" : "station-status-disable-opacity"}`}>
                        {member.hasStationsProtection ? (
                          <>
                            <i
                              onClick={() => {
                                isBtaxMemberShipEdit[index] &&
                                  props.handleMemberChange("btaxMembers", "hasStationsProtection", index, false);
                              }}
                              class="material-icons primary-color"
                            >
                              desktop_access_disabled
                            </i>
                            <FormControl>
                              <Select
                                disabled={!isBtaxMemberShipEdit[index]}
                                value={member.stationsAmount || 1}
                                onChange={(e) => props.handleMemberChange("btaxMembers", "stationsAmount", index, e.target.value)}
                              >
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                              </Select>
                            </FormControl>
                            <div
                              onClick={() => isBtaxMemberShipEdit[index] && props.resetStations(member)}
                              className={`inline-block mr-20 ${isBtaxMemberShipEdit[index] ? "pointer" : "station-status-disable-opacity"}`}
                            >
                              <i class="material-icons">autorenew</i>
                            </div>
                          </>
                        ) : (
                          <i
                            onClick={() =>
                              isBtaxMemberShipEdit[index] && props.handleMemberChange("btaxMembers", "hasStationsProtection", index, true)
                            }
                            class="material-icons"
                          >
                            laptop_windows
                          </i>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>דוא"ל</td>
                    <td>
                      <TextField
                        onChange={(e) => props.handleMemberChange("btaxMembers", "email", index, e.target.value)}
                        disabled={!isBtaxMemberShipEdit[index]}
                        value={member.email || ""}
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>שם פרטי</td>
                    <td>
                      <TextField
                        onChange={(e) => props.handleMemberChange("btaxMembers", "firstName", index, e.target.value)}
                        disabled={!isBtaxMemberShipEdit[index]}
                        value={member.firstName !== undefined && member.firstName !== null ? member.firstName : getFirstNameFromFullName(member.fullName)}
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>שם משפחה</td>
                    <td>
                      <TextField
                        onChange={(e) => props.handleMemberChange("btaxMembers", "lastName", index, e.target.value)}
                        disabled={!isBtaxMemberShipEdit[index]}
                        value={member.lastName !== undefined && member.lastName !== null ? member.lastName : getLastNameFromFullName(member.fullName)}
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>מספר נייד</td>
                    <td>
                      <TextField
                        onChange={(e) => props.handleMemberChange("btaxMembers", "mobile", index, e.target.value)}
                        disabled={!isBtaxMemberShipEdit[index]}
                        value={member.mobile || ""}
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>תוקף מנוי</td>
                    <td>
                      <TextField
                        type="date"
                        defaultValue={moment(new Date(member.endOfSubscription)).format("YYYY-MM-DD")}
                        onChange={(e) => {
                          const date = new Date(e.target.value);
                          let finalValue = e.target.value;

                          if (date.getMonth() === 1) {
                            // February
                            const day = date.getDate();
                            if (day === 15 || day === 16) {
                              if (cardJobTitle === "shamai") {
                                Swal.fire({
                                  title: `יש לשים לב שנבחר תאריך מיוחד שבו יש רק שמאי לשכה שאינם משלמים על המערכת. אם לא מדובר בשמאי בבקשה לשנות את השדה של "עיסוק" וגם לשנות לתאריך אחר את סיום המנוי לדוגמה ה-17.`,
                                  icon: "info",
                                  confirmButtonColor: "#e9d700"
                                });
                              } else {
                                date.setDate(17);
                                finalValue = moment(date).format("YYYY-MM-DD");
                                e.target.value = finalValue;
                              }
                            }
                          }

                          props.handleMemberChange("btaxMembers", "endOfSubscription", index, finalValue);
                        }}
                        disabled={!isBtaxMemberShipEdit[index]}
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>סטטוס</td>
                    <td>
                      <FormControl>
                        <Select
                          onChange={(e) => props.handleMemberChange("btaxMembers", "status", index, e.target.value)}
                          value={member.status || ""}
                          disabled={!isBtaxMemberShipEdit[index]}
                          displayEmpty
                        >
                          <MenuItem value="active">פעיל</MenuItem>
                          <MenuItem value="suspended">מושהה</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>תפקיד</td>
                    <td>
                      <FormControl>
                        <Select
                          onChange={(e) => props.handleMemberChange("btaxMembers", "jobType", index, e.target.value)}
                          value={member.jobType || ""}
                          disabled={!isBtaxMemberShipEdit[index]}
                          displayEmpty
                        >
                          <MenuItem value="regular">רגיל</MenuItem>
                          <MenuItem value="manager">מנהל</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>מס' רשיון</td>
                    <td>
                      <TextField
                        onChange={(e) => props.handleMemberChange("btaxMembers", "licenseNumber", index, e.target.value)}
                        disabled={!isBtaxMemberShipEdit[index]}
                        value={member.licenseNumber || ""}
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>שימוש בתוכנה</td>
                    <td>
                      <FormControl>
                        <Select
                          onChange={(e) => props.handleMemberChange("btaxMembers", "softwareServiceType", index, e.target.value)}
                          value={member.softwareServiceType || ""}
                          disabled={!isBtaxMemberShipEdit[index]}
                          displayEmpty
                        >
                          <MenuItem value="btax">BTax</MenuItem>
                          <MenuItem value="btaxYam">BTax Yam</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td style={{ width: 120 }}>עדכון הלקוח 30 יום לפני סיום המנוי?</td>
                    <td>
                      <FormControl>
                        <Select
                          onChange={(e) => props.handleMemberChange("btaxMembers", "isUpdateClientBeforeEndSub", index, e.target.value)}
                          value={member.isUpdateClientBeforeEndSub}
                          disabled={!isBtaxMemberShipEdit[index]}
                          displayEmpty
                        >
                          <MenuItem value={true}>כן</MenuItem>
                          <MenuItem value={false}>לא</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td style={{ width: 120 }}>דלג על אישור לפני הפקת מסמכי רשות המסים?</td>
                    <td>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={!!member.disableTaxAuthorityDocumentConfirmation}
                            onChange={(e) =>
                              props.handleMemberChange(
                                "btaxMembers",
                                "disableTaxAuthorityDocumentConfirmation",
                                index,
                                e.target.checked
                              )
                            }
                            disabled={!isBtaxMemberShipEdit[index]}
                          />
                        }
                        label={member.disableTaxAuthorityDocumentConfirmation ? "כן" : "לא"}
                      />
                    </td>
                  </tr>
                </tbody>
                {member.softwareServiceType === "btax" ? (
                  <tbody>
                    <tr>
                      <td>הרחבות</td>
                      <td>
                        <TextField
                          disabled={!isBtaxMemberShipEdit[index]}
                          value={member.abilities || []}
                          type="select"
                          select={true}
                          SelectProps={{ multiple: true }}
                          variant="outlined"
                          size="small"
                          onChange={(e) => props.handleMemberAbilitiesChange("btaxMembers", index, e.target.value)}
                        >
                          <MenuItem value="combination">קומבינציה</MenuItem>
                          <MenuItem value="prisaExt">פריסה מורחב</MenuItem>
                        </TextField>
                      </td>
                    </tr>
                  </tbody>
                ) : null}

                <tbody>
                  <tr>
                    <td>תאריך יצירה</td>
                    <td>
                      <span>{moment(new Date(member.dateCreated).toString()).format("YYYY-MM-DD") || ""}</span>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>האם אישר דוא"ל</td>
                    <td>
                      <span>{member.isEmailConfirmed ? "כן" : "לא"}</span>
                    </td>
                  </tr>
                </tbody>

                {role === "admin" && (
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <div>
                          <hr />
                          <RadioGroup
                            value={member.attachRole}
                            className="flex-direction-row"
                            onChange={(e) => {
                              props.handleMemberChange("btaxMembers", "attachRole", index, e.target.value);
                            }}
                          >
                            <FormControlLabel value="" control={<Radio />} label="regular" />
                            <FormControlLabel value="salesManager" control={<Radio />} label="salesManager" />
                            <FormControlLabel value="salesman" control={<Radio />} label="salesman" />
                          </RadioGroup>

                          <TextField
                            value={member.adminSetManualPassword}
                            label="Manual password"
                            onChange={(e) => {
                              props.handleMemberChange("btaxMembers", "adminSetManualPassword", index, e.target.value);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </Fragment>
            );
          })}
        </table>
      ) : null}

      {role === "admin" && (
        <>
          <div className="relative">
            <h6 className="black-color underline mt-20">ביקוויק</h6>
            <Add
              onClick={() => {
                if (props.bquickMembers.length >= config.maxMembersAllowedPerOffice) {
                  return Swal.fire("מקסימום משתמשים במשרד זה", "", "warning");
                }
                setNewMemberType("bquickMembers");
                setIsNewMemberPopupOpen(true);
              }}
              className="icon-circles yellow-color adjust-add-btn"
            />
          </div>
          {props.focusedViewTypes.includes("bquick") || props.focusedViewTypes.includes("all") ? (
            <table>
              {props.bquickMembers.map((member, index) => {
                return (
                  <Fragment key={member._id}>
                    <tbody>
                      <tr>
                        <td>
                          ---- <b className={isMemberActive(member) ? "black-color" : "text-danger"}>{index + 1}</b> ----
                        </td>
                        <td className="relative pb-40">
                          <div className="memberships-icons">
                            {isBquickMemberShipEdit[index] ? (
                              <Fragment>
                                <div className="inline-block animation-right">
                                  <Delete
                                    style={{ fontSize: 29 }}
                                    onClick={() =>
                                      props
                                        .handleMemberUpdate("bquickMembers", index, "DELETE")
                                        .then((isUpdated) => isUpdated && deleteDone("bquickMembers", index))
                                    }
                                    className="active-color icon-circles"
                                  />
                                  <CheckCircle
                                    style={{ fontSize: 29 }}
                                    onClick={() =>
                                      props
                                        .handleMemberUpdate("bquickMembers", index, "UPDATE")
                                        .then((isUpdated) => isUpdated && changeEditableState("bquickMembers", index, false))
                                    }
                                    className="success-color mr-20 icon-circles"
                                  />
                                </div>

                                <Cancel
                                  style={{ fontSize: 29 }}
                                  onClick={() => changeEditableState("bquick", index, false)}
                                  className="mr-20 icon-circles"
                                />

                                <div className="left mt-20 animation-down">
                                  <LockOpen
                                    style={{ fontSize: 29 }}
                                    className="brown-color mr-20 icon-circles"
                                    onClick={() =>
                                      props
                                        .initMemberReconf("bquickMembers", index, "PASS_RESET")
                                        .then(() => changeEditableState("bquick", index, false))
                                    }
                                  />

                                  <div className="mt-20 relative">
                                    {bquickMemberTransfer[index].isTransfering ? (
                                      <div className="change-member-card">
                                        <input
                                          value={bquickMemberTransfer[index].newCardNum || ""}
                                          onChange={(e) =>
                                            changeTransferingState("bquick", index, {
                                              ...bquickMemberTransfer[index],
                                              newCardNum: e.target.value
                                            })
                                          }
                                          type="txt"
                                        />
                                        <button
                                          onClick={() =>
                                            props.transferMemberToOtherCard("bquickMembers", index, bquickMemberTransfer[index].newCardNum)
                                          }
                                        >
                                          שנה
                                        </button>
                                      </div>
                                    ) : null}

                                    <SyncAlt
                                      style={{ fontSize: 29 }}
                                      className="primary-color mr-20 icon-circles"
                                      onClick={() =>
                                        changeTransferingState("bquick", index, {
                                          ...bquickMemberTransfer[index],
                                          isTransfering: !bquickMemberTransfer[index].isTransfering
                                        })
                                      }
                                    />
                                  </div>

                                  {member.isEmailConfirmed ? null : (
                                    <div className="mt-20">
                                      <MailOutline
                                        style={{ fontSize: 29 }}
                                        className="yellow-color mr-20 icon-circles"
                                        onClick={() =>
                                          props
                                            .initMemberReconf("bquickMembers", index, "EMAIL_CONF")
                                            .then(() => changeEditableState("bquick", index, false))
                                        }
                                      />
                                    </div>
                                  )}
                                </div>
                              </Fragment>
                            ) : (
                              <Edit
                                style={{ fontSize: 29 }}
                                onClick={() => changeEditableState("bquick", index, true)}
                                className="icon-circles"
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>דוא"ל</td>
                        <td>
                          <span>{member.email || ""}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>שם מלא</td>
                        <td>
                          <TextField
                            onChange={(e) => props.handleMemberChange("bquickMembers", "fullName", index, e.target.value)}
                            disabled={!isBquickMemberShipEdit[index]}
                            value={member.fullName || ""}
                          />
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>תוקף מנוי</td>
                        <td>
                          <TextField
                            id="date"
                            type="date"
                            defaultValue={moment(new Date(member.endOfSubscription)).format("YYYY-MM-DD")}
                            onChange={(e) => props.handleMemberChange("bquickMembers", "endOfSubscription", index, e.target.value)}
                            disabled={!isBquickMemberShipEdit[index]}
                          />
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>סטטוס</td>
                        <td>
                          <FormControl>
                            <Select
                              onChange={(e) => props.handleMemberChange("bquickMembers", "status", index, e.target.value)}
                              value={member.status || ""}
                              disabled={!isBquickMemberShipEdit[index]}
                              displayEmpty
                            >
                              <MenuItem value="active">פעיל</MenuItem>
                              <MenuItem value="suspended">מושהה</MenuItem>
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>תאריך יצירה</td>
                        <td>
                          <span>{moment(new Date(member.dateCreated).toString()).format("YYYY-MM-DD") || ""}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>תפקיד</td>
                        <td>
                          <FormControl>
                            <Select
                              onChange={(e) => props.handleMemberChange("bquickMembers", "jobType", index, e.target.value)}
                              value={member.jobType || ""}
                              disabled={!isBquickMemberShipEdit[index]}
                              displayEmpty
                            >
                              <MenuItem value="regular">רגיל</MenuItem>
                              <MenuItem value="manager">מנהל</MenuItem>
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>האם אישר דוא"ל</td>
                        <td>
                          <span>{member.isEmailConfirmed ? "כן" : "לא"}</span>
                        </td>
                      </tr>
                    </tbody>

                    {role === "admin" && (
                      <tbody>
                        <tr>
                          <td colspan="2">
                            <div>
                              <hr />
                              <RadioGroup
                                value={member.attachRole}
                                className="flex-direction-row"
                                onChange={(e) => {
                                  props.handleMemberChange("bquickMembers", "attachRole", index, e.target.value);
                                }}
                              >
                                <FormControlLabel value="" control={<Radio />} label="regular" />
                                <FormControlLabel value="salesManager" control={<Radio />} label="salesManager" />
                                <FormControlLabel value="salesman" control={<Radio />} label="salesman" />
                              </RadioGroup>

                              <TextField
                                value={member.adminSetManualPassword}
                                label="Manual password"
                                onChange={(e) => {
                                  props.handleMemberChange("bquickMembers", "adminSetManualPassword", index, e.target.value);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </Fragment>
                );
              })}
            </table>
          ) : null}
        </>
      )}
    </div>
  );

  function changeTransferingState(type, index, val) {
    if (type === "btax") {
      const btaxList = [...btaxMemberTransfer];
      btaxList[index] = val;
      setBtaxMemberTransfer(btaxList);
    } else {
      const bquickList = [...bquickMemberTransfer];
      bquickList[index] = val;
      setBquickMemberTransfer(bquickList);
    }
  }

  function changeEditableState(type, index, val) {
    if (type === "btax") {
      const btaxList = [...isBtaxMemberShipEdit];
      btaxList[index] = val;
      setIsBtaxMemberShipEdit(btaxList);
    } else {
      const bquickList = [...isBquickMemberShipEdit];
      bquickList[index] = val;
      setIsBquickMemberShipEdit(bquickList);
    }
  }

  function tryAddNewMemberAndPushList(data, newMemberType) {
    props.tryAddNewMemberAndPushList(data, newMemberType).then(() => {
      setIsNewMemberPopupOpen(false);
      if (newMemberType === "btax") {
        const newIsBtaxMemberShipEdit = [...isBtaxMemberShipEdit];
        const newBtaxMemberTransfer = [...btaxMemberTransfer];

        newIsBtaxMemberShipEdit.push(false);
        newBtaxMemberTransfer.push({ isTransfering: false });

        setIsBtaxMemberShipEdit(newIsBtaxMemberShipEdit);
        setBtaxMemberTransfer(newBtaxMemberTransfer);
      } else {
        const newIsBquickMemberShipEdit = [...isBquickMemberShipEdit];
        const newBquickMemberTransfer = [...bquickMemberTransfer];

        newIsBquickMemberShipEdit.push(false);
        newBquickMemberTransfer.push({ isTransfering: false });

        setIsBquickMemberShipEdit(newIsBquickMemberShipEdit);
        setBquickMemberTransfer(newBquickMemberTransfer);
      }
    });
  }

  function deleteDone(type, index) {
    if (type === "btaxMembers") {
      const newIsBtaxMemberShipEdit = [...isBtaxMemberShipEdit];
      const newBtaxMemberTransfer = [...btaxMemberTransfer];

      newIsBtaxMemberShipEdit.splice(index, 1);
      newBtaxMemberTransfer.splice(index, 1);

      setIsBtaxMemberShipEdit(newIsBtaxMemberShipEdit);
      setBtaxMemberTransfer(newBtaxMemberTransfer);
    } else {
      const newIsBquickMemberShipEdit = [...isBquickMemberShipEdit];
      const newBquickMemberTransfer = [...bquickMemberTransfer];

      newIsBquickMemberShipEdit.splice(index, 1);
      newBquickMemberTransfer.splice(index, 1);

      setIsBquickMemberShipEdit(newIsBquickMemberShipEdit);
      setBquickMemberTransfer(newBquickMemberTransfer);
    }
  }
}

function getFirstNameFromFullName(fullName = "") {
  return fullName.split(" ")[0] || "";
}

function getLastNameFromFullName(fullName = "") {
  const nameParts = fullName.split(" ").filter(Boolean);
  return nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
}

export default Memberships;
